import LinesSkeleton from './LinesSkeleton';

interface SkeletonWrapperProps {
    children: any;
    loading?: boolean;
    skeletonLines?: number;
}

function SkeletonWrapper(props: SkeletonWrapperProps) {
  const { children, loading, skeletonLines } = props;
  return loading
    ? <LinesSkeleton lines={skeletonLines} />
    : children;
}

export default SkeletonWrapper;